
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { prop } from 'ramda';
import { getCurrentStep, getPOSData } from '@olxbr/mojo-jojo/selectors/pos';
import { getAdData } from '@olxbr/mojo-jojo/selectors/ad';
import { changeCurrentStep } from '@olxbr/mojo-jojo/actions/meta';

import SwitchStep from './SwitchStep';
import { trackSwitchStep } from '../services/tracking';

const getAdId = prop('legacyAdId');
const getListId = prop('listId');
const getName = prop('name');
const getFunnelId = prop('funnelId');

const mapStateToProps = state => ({
  adId: getAdId(getAdData(state)),
  listId: getListId(getAdData(state)),
  pointOfSale: getName(getPOSData(state)),
  currentStep: getCurrentStep(state),
  funnelId: getFunnelId(getPOSData(state)),
});

const mapDispatchToProps = { changeCurrentStep };

const configureHandlers = withHandlers({
  onClick: ({
    adId,
    listId,
    pointOfSale,
    currentStep,
    funnelId,
    ...props
  }) => () => {
    trackSwitchStep({
      adId, listId, pointOfSale, step: currentStep.nextStep, funnelId,
    });
    props.changeCurrentStep(currentStep.nextStep);
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  configureHandlers,
)(SwitchStep);
